import { DefaultOptions, QueryClient } from '@tanstack/react-query';
import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';

// TODO: These defaults make for a worse user experience; we should re-evaluate them
const configurationDefaults: DefaultOptions = {
  queries: {
    retry: false,
    staleTime: Infinity,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchInterval: false,
    refetchIntervalInBackground: false,
    gcTime: Infinity,
  },
};

export const queryClient = new QueryClient({
  defaultOptions: {
    ...configurationDefaults,
  },
});

export const persister = createAsyncStoragePersister({
  storage: window.localStorage,
});
